import { useWidget, useTheme } from '@telescope/cassini-hooks';
import {
  Button,
  ButtonGroup,
  Flex,
  useColorModeValue
} from '@telescope/cassini-ui';
import { useAuth } from '../lib';
import { Open, Closed } from 'generated-types/widget';
import { useEffect } from 'react';

export const AuthNav = () => {
  const { user, logout } = useAuth();
  const { data } = useWidget({ select: (data: Open) => data.widget.global_views.auth });
  const { content } = data!;
  const { data: snapshotType } = useWidget({ select: (data: Open | Closed) => data.snapshot.type });

  const theme = useTheme();
  const { defaultColorScheme: c } = theme.settings;
  const color = useColorModeValue(`${c}.900`, `${c}.50`);

  // Log user out when snapshot changes
  useEffect(() => {
    return () => {
      handleLogout();
    }
  }, [snapshotType, logout]);

  const handleLogout = async () => {
    await logout();
  };

  return (
    <Flex className="AuthNav" justifyContent="flex-end">
      <ButtonGroup className="AuthNav__auth-btn-group" size="sm">
        { user &&
          <Button className="AuthNav__logout-btn" variant="link" onClick={handleLogout} color={color} _hover={{color: `${c}.500`}} textDecoration="underline">
            {content.user.logoutCTA}
          </Button> }
      </ButtonGroup>
    </Flex>
  );
};
